import React from 'react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_fleet-shares/artifacts/zom2vol7_ChatGPT%20Image%20Jan%2025%2C%202026%2C%2012_41_13%20PM.png";

export const FleetSharesLogo = ({ size = 'medium', showText = false }) => {
  const sizes = {
    small: 'h-12',
    header: 'h-32 md:h-40 lg:h-48',  // Header logo - 7x BIGGER!
    medium: 'h-24',        
    large: 'h-40',         
    xlarge: 'h-56',        
    hero: 'h-80 md:h-96 lg:h-[28rem]',  // Login page - MASSIVE!
  };

  return (
    <div className="flex items-center gap-3">
      <img
        src={LOGO_URL}
        alt="Fleet Shares Logo"
        className={`${sizes[size]} w-auto object-contain`}
      />
    </div>
  );
};

export const FleetSharesLogoWhite = FleetSharesLogo;
